module.exports = __webpack_public_path__ + "img/gallery11111.c91b868d.jpeg";